module.exports = __webpack_public_path__ + "static/media/craft-03.9d148ed5.svg";